import React, { Suspense } from 'react';
import { Outlet } from 'react-router';

import { AxiosInterceptorProvider } from 'contexts/AxiosInterceptorContext';
import { UserProvider } from 'contexts/UserContext';

const MobileAppBanner = React.lazy(
  () => import('shared/components/MobileAppBanner/MobileAppBanner'),
);

export function Root() {
  return (
    <AxiosInterceptorProvider>
      <>
        <Suspense fallback={null}>
          <MobileAppBanner />
        </Suspense>
        <UserProvider>
          <Outlet />
        </UserProvider>
      </>
    </AxiosInterceptorProvider>
  );
}

export default Root;
